import { makeContext } from '@core/context/makeContext';
import { AnalyticsService } from 'modules/Analytics/analytics.interface';

export const {
  Provider: AnalyticsServiceContextProvider,
  useContext: useAnalytics,
} = makeContext<AnalyticsService>('AnalyticsService');
